import { SetFiltersEvent } from "../../events";
import { BindRecord } from "./frontend";

export class ScoreFrontend {
	getBindScoreFilter(): BindRecord {
		return new BindRecord(
			document.querySelectorAll('.summary .score-filter'),
			'click',
			element => {
				/** @type {CustomEvent[]} */
				const filters: string[] = [
					element.dataset.filterSection, element.dataset.filterAnswer
				].filter(v => v);
				const events: CustomEvent[] = [new SetFiltersEvent(filters.map(filter => filter))];
				return events;
			}
		)
	}

	bindSummaryCollapse(): void {
		const collapse = document.querySelector('.summary.collapse');
		const collapser = document.querySelector('.summary-collapser');
		const label = collapser?.querySelector('span');
		if (label) {
			collapse?.addEventListener('show.bs.collapse', e => {
				label.innerText = 'Hide Summary';
			});
			collapse?.addEventListener('hide.bs.collapse', e => {
				label.innerText = 'Show Summary';
			});
		}
	}

	getSectionScoreChart(): HTMLElement | null {
		return document.querySelector('.score-chart');
	}
}

